import { goToBack } from "../modules/modal";

const self = {
  screen: "",
};

function startPolling() {
  setInterval(checkHash, 100);
}

function checkHash() {
  const hash = window.location.hash || "#";
  const bbPressed = hash !== "#" + self.screen;

  if (bbPressed) {
    self.dispatch(goToBack());
  }
}

export default {
  init(store) {
    if (window.location.hash) {
      window.history.replaceState(null, null, "#");
    }
    self.dispatch = store.dispatch;
    startPolling();
  },
  setCurrentScreen(screen) {
    window.history.pushState(null, null, `#${screen}`);

    self.screen = screen;
  },
};
